"use client";
import styles from './Banner.module.css';
import React, { useState, useRef, useEffect } from "react";
import Container from "@mui/material/Container";
import CeoMessage from "../../CeoMessage/CeoMessage";
import { style } from '@mui/system';
import SlideOne from './SlideOne';
import Image from 'next/image';



const Banner = () => {
  const slides = [
    { id: 1, text: <SlideOne /> },
    // { id: 1, img:"https://cdn.mytakbir.com/static-assets/banner/takbir-sirajul-islam-banner-slide.webp",},
    // { id: 2, img:"https://cdn.mytakbir.com/static-assets/banner/takbir-dr-suzy-ismail-banner-slide.webp",},

  ];

  const SLIDE_DURATION = 5000; // in ms

  const [currentIndex, setCurrentIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (slides.length > 1) {
      startProgressBar();
    }
    return () => clearInterval(intervalRef.current);
  }, [currentIndex]);

  const startProgressBar = () => {
    setProgress(0);
    let startTime = Date.now();

    intervalRef.current = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const percentage = (elapsed / SLIDE_DURATION) * 100;
      setProgress(Math.min(100, percentage));

      if (percentage >= 100) {
        clearInterval(intervalRef.current);
        goToNextSlide();
      }
    }, 100);
  };

  const goToNextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % slides.length);
  };

  const goToSlide = (index) => {
    clearInterval(intervalRef.current);
    setCurrentIndex(index);
  };

  return (
    <>
      {/* <CeoMessage /> */}
      <div className={styles.carousel}>
        <div className={styles.carouselSlide}>
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`slide ${index === currentIndex ? 'active-slide' : ''}`}
            >
              {slide.text}
              {/* <Image
                src={slide.img}
                alt="Background"
                width={1920}
                height={1080}
                priority
                className={styles.SlideBanner}
              /> */}
            </div>
          ))}
        </div>

        {/* Only show bullets if more than 1 slide */}
        {slides.length > 1 && (
          <div className={styles.CarouselBullets}>
            {slides.map((_, index) => (
              <div
                key={index}
                className={`bullet ${index === currentIndex ? 'active-slide' : ''}`}
                onClick={() => goToSlide(index)}
              >
                {index === currentIndex && (
                  <div
                    className="progress-fill"
                    style={{ width: `${progress}%` }}
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Banner;
